import { render, staticRenderFns } from "./ShortVideo.vue?vue&type=template&id=5eafdb0f&scoped=true"
import script from "./ShortVideo.vue?vue&type=script&lang=js"
export * from "./ShortVideo.vue?vue&type=script&lang=js"
import style0 from "./ShortVideo.vue?vue&type=style&index=0&id=5eafdb0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eafdb0f",
  null
  
)

export default component.exports